import { useState, useRef, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import { MainBg } from "./MainBg";
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { inputBgColor } from "./Scan";
import { enqueueSnackbar,closeSnackbar } from 'notistack';
import CloseIcon from "../asset/misc/Close";

import {newSessionUID, getApplicationImage, APPFACTOR, capitalize, decamelize,errorOptions,infoOptions, DEBUG_LEVEL_VAL} from "./commons";
import { wPostMessage, setTheConfig } from "./EnterSecretPassword";
import HorizontalMenu from "./HorizontalMenu";


const UID_CREATE = "10000100-f00d-face-abba-aabbbbaa";

function setNewConfig(theID) {
    let newID = newSessionUID();

    if (!window.createdNewSettings) {
        window.createdNewSettings = [];
    }


    window.createdNewSettings.push(newID);
    let data = window.payloadData[theID].payloadData;
    let orchestratorConfig = window.payloadData[theID].orchestratorConfig;

    let payload =
    {
        "type": "set_scanner_config",
        "id": newID,
        scanner_config: {
            ...orchestratorConfig,
        }
    }


    if (data?.deleteNewUserPass) {
        payload.scanner_config.http_client = null;
    }
    else {
        if (data.api_url_prefix && data.api_url_prefix.length > 0) {
            payload.scanner_config.api_url_prefix = data.api_url_prefix;
        }

        if (data.http_client) {
            if (!payload?.scanner_config?.http_client) {
                payload.scanner_config.http_client = {};
            }

            if (data.http_client.http_proxy && data.http_client.http_proxy.length > 0) {
                payload.scanner_config.http_client.http_proxy = data.http_client.http_proxy;
                if (window.payloadData[theID]?.payloadSecret?.secret_key) {
                    payload.scanner_config.http_client.http_proxy_auth_secret_ref = window.payloadData[theID].payloadSecret.secret_key;
                }
            }

            if (data?.http_client?.ignore_certificate_errors) {
                payload.scanner_config.http_client.ignore_certificate_errors = data?.http_client?.ignore_certificate_errors;
            }
        }

        if (data.http_client.extra_ca_certs_file && data.http_client.extra_ca_certs_file.length > 0) {
            if (!payload?.scanner_config?.http_client) {
                payload.scanner_config.http_client = {};
            }

            payload.scanner_config.http_client.extra_ca_certs_file = data.http_client.extra_ca_certs_file;
            payload.scanner_config.http_client.extra_ca_certs = null;

        }

        if (data.http_client.extra_ca_certs && data.http_client.extra_ca_certs.length > 0) {
            if (!payload?.scanner_config?.http_client) {
                payload.scanner_config.http_client = {};
            }

            payload.scanner_config.http_client.extra_ca_certs = data.http_client.extra_ca_certs;
            payload.scanner_config.http_client.extra_ca_certs_file = null;
        }
    }
    payload.scanner_config.keep_downloaded_scanner = data.keep_downloaded_scanner;


    window.postMessage(
        JSON.stringify(
            {
                type: APPFACTOR.command,
                scanRaw: true,
                payload:
                {
                    ...payload
                }
            }
        )
    )

}
function processCreation(event) {
    try {

        if (!window.createdNewSettings) {
            window.createdNewSettings = [];
        }

        let eventData = JSON.parse(event.data);

        if (window.createdNewSettings.includes(eventData.id)) {
            if (eventData.success === false) {
                window.setIndexSetError(eventData?.error || "Please verify data source configuration");
            } else {
                window.closeAddIndexPage();
            }


        } else
            if (eventData?.id?.indexOf(UID_CREATE) == 0) {
                if (eventData.completed === true && eventData.success === true) {
                    setNewConfig(eventData.id)

                } else {
                    if (eventData.success === false) {
                        window.setIndexSetError(eventData?.error || "Please verify data source configuration");
                    }
                }
            }
    } catch (e) {
        console.log("processCreation error", e);
    }
}


function DividerLight() {
    return <Divider style={{ marginLeft: 20, marginTop: 10, marginBottom: -10, marginRight: 90, opacity: 0.2 }} />
}

export const hv = "10px";

function InputElement(keyVal, isDarkMode, setCurrentItemData, focus, buttonRef, setIndexSetError, currentItemData, disableElement, placeholder) {
    const isCheckbox = keyVal == "ignore_certificate_errors" || keyVal == "keep_downloaded_scanner";
    const isUserPassword = (keyVal == "proxyUser" || keyVal == "proxyPassword");

    return <div
        key={"in_" + keyVal}
        style={{
            position: "relative",
            paddingTop: 16,
            paddingLeft: 20,
        }}>
        <div
            id={"input_label_" + keyVal}

            style={{
                textTransform: "capitalize",
                opacity: 0.5,
                textAlign: isCheckbox ? "left" : "right",
                fontSize: 13,
                display: "inline-block",
                minWidth: isCheckbox ? "180px" : "120px",
            }}>{keyVal != "extra_ca_certs"?capitalize(decamelize(keyVal)):""}&nbsp;</div>

        {keyVal == "extra_ca_certs" ?
            <>
            <div
            style={{
                textTransform: "capitalize",
                opacity: 0.5,
                textAlign: "right",
                fontSize: 13,
                display: "inline-block",
                position:"absolute",
                marginTop:20,
                marginLeft:-125,
                minWidth:  "120px",
            }}

            >{capitalize(decamelize(keyVal))}</div>
                <textarea
                    id={"input_" + keyVal}
                    defaultValue={currentItemData?.[keyVal]}
                    {...(focus == true ? { autoFocus: true } : {})}
                    onChange={(e) => {
                        if (disableElement) {
                            try {
                                let el = document.getElementById("input_" + disableElement);
                                let label = document.getElementById("input_label_" + disableElement);

                                if (e.target.value == "") {
                                    el.disabled = false;
                                    el.style.opacity = "1";
                                    label.style.opacity = "0.5";
                                } else {
                                    el.disabled = true;
                                    el.style.opacity = "0.2";
                                    label.style.opacity = "0.1";
                                }
                            } catch (err) {
                                /**/
                            }
                        }
                        setCurrentItemData(
                            prev => ({
                                ...prev,
                                [keyVal]: e.target.value,
                            }))
                    }}
                    style={{
                        resize: "none",
                        width: "calc(100% - 250px)",
                        maxWidth: "calc(100% - 250px)",
                        minWidth: "calc(100% - 250px)",
                        marginLeft: 10,
                        height: hv,
                        minHeight: hv,
                        maxHeight: hv,
                        outline: "none",
                        backgroundColor: inputBgColor(isDarkMode),
                        color: isDarkMode ? "white" : "black",
                        border: "none",
                        boxShadow: "none",
                        borderRadius: 8,
                        padding: 15,
                    }}
                />
            </>
            :
            <>
                <input
                    readOnly={keyVal == "api_url_prefix" || (isUserPassword && currentItemData?.http_client?.http_proxy_auth_secret_ref?.length > 0)}
                    autoComplete={'one-time-code'}
                    id={"input_" + keyVal}
                    defaultValue={isUserPassword ? currentItemData?.http_client?.http_proxy_auth_secret_ref?.split("_")[0] : currentItemData?.[keyVal]}
                    {...(focus == true ? { autoFocus: true } : {})}
                    {...(isCheckbox ? { checked: `${currentItemData[keyVal]}` == `true` } : {})}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                            if (e.target?.value?.trim()?.length === 0) {
                                setIndexSetError(`Please enter a value for "` + capitalize(decamelize(keyVal)) + `"`);
                                return;
                            }
                            setCurrentItemData(prev => ({
                                ...prev,
                                [keyVal]: e.target.value,
                            }))

                            try {
                                if (buttonRef) {
                                    buttonRef.current.focus();
                                } else {
                                    const input = e.target.parentNode.nextSibling.querySelector("input");
                                    input.focus()
                                }
                            } catch (err) {
                            }
                        }
                    }}
                    type={(keyVal === "token" || keyVal?.toLowerCase().indexOf("password") > -1) ? "password" :
                        isCheckbox ? "checkbox" : "text"}
                    {...(placeholder ? { placeholder: placeholder } : {})}
                    style={{
                        width: isCheckbox ? 40 : "calc(100% - 250px)",
                        marginLeft: 10,
                        height: hv,
                        minHeight: hv,
                        maxHeight: hv,
                        // minHeight: (keyVal == "extra_ca_certs") ? 100 : 12,
                        outline: "none",
                        backgroundColor: keyVal == "api_url_prefix" ? "rgba(0,0,0,0)" : inputBgColor(isDarkMode),
                        color: isDarkMode ? "white" : "black",
                        border: "none",
                        boxShadow: "none",
                        borderRadius: 8,
                        padding: 15,
                    }}
                    onChange={(e) => {
                        if (isCheckbox) {
                            if (`${e.target.value}` == `on`) {
                                setIsChecked(false);
                            } else {
                                setIsChecked(true);
                            }
                        }

                        if (disableElement) {
                            try {
                                let el = document.getElementById("input_" + disableElement);
                                let label = document.getElementById("input_label_" + disableElement);

                                if (e.target.value == "") {
                                    el.disabled = false;
                                    el.style.opacity = "1";
                                    label.style.opacity = "0.5";
                                } else {
                                    el.disabled = true;
                                    el.style.opacity = "0.2";
                                    label.style.opacity = "0.1";
                                }
                            } catch (err) {
                                /**/
                            }
                        }

                        setCurrentItemData(
                            prev => ({
                                ...prev,
                                [keyVal]: isCheckbox ? (`${e.target.value}` == `on` ? true : false) : e.target.value,
                                ...(isUserPassword ? { newUserPass: true } : {})
                            }))
                    }} />
                {(isUserPassword || keyVal == "http_proxy") &&
                    <div
                    className="closeStyledTagTxt"
                    title={
                        (keyVal == "proxyUser" ? "Clear username and password" : (keyVal == "proxyPassword" ? "Clear password": "Clear all proxy settings") )}
                        style={{
                            fontSize:12,
                            
                            width: 19,
                            minWidth:46,
                            maxWidth: 46,
                            maxHeight: 19,
                            padding: 0,
                            margin: 0,
                            textAlign:"center",
                            position: "absolute",
                            right: 36,
                            top: 30,
                        }}
                        onClick={(e) => {
                            let el = document.getElementById("input_proxyUser");
                            let el2 = document.getElementById("input_proxyPassword");
                            let el3 = document.getElementById("input_http_proxy");

                            if (el) {
                                if (keyVal == "proxyUser") {
                                    el.value = "";
                                    el2.value = "";
                                    el.focus();

                                    setCurrentItemData(prev => ({
                                        ...prev,
                                        http_client: {
                                            ...prev.http_client,
                                            http_proxy_auth_secret_ref: null,

                                        },
                                        proxyUser: "",
                                        proxyPassword: ""
                                    }))

                                } else if (keyVal == "proxyPassword") {
                                    el.value = orchestratorConfig?.http_client?.http_proxy_auth_secret_ref?.split("_")[0] || "";
                                    el2.value = "";
                                    el2.focus();

                                    setCurrentItemData(prev => ({
                                        ...prev,
                                        http_client: {
                                            ...prev.http_client,
                                            http_proxy_auth_secret_ref: null,
                                        },
                                        proxyUser: el.value,
                                        proxyPassword: ""
                                    }))

                                } else if (keyVal == "http_proxy") {
                                    try{ document.getElementById("input_extra_ca_certs").value = ""; } catch(e) { /**/ }
                                    try{ document.getElementById("input_extra_ca_certs_file").value = ""; } catch(e) { /**/ }
                                    el3.value = "";
                                    el.value = "";
                                    el2.value = "";

                                    el3.focus();

                                    setCurrentItemData(prev => {
                                        let newSettings = {
                                            ...prev,
                                            http_client: null,
                                            proxyUser: el.value,
                                            proxyPassword: ""
                                        }

                                        newSettings.deleteNewUserPass = true;

                                        try { delete newSettings.proxyUser; } catch (e) { /**/ }
                                        try { delete newSettings.proxyPassword; } catch (e) { /**/ }

                                        return newSettings;
                                    });

                                    setTimeout(() => {
                                        console.log("click",document.getElementById("saveSettingsButton"));
                                        document.getElementById("saveSettingsButton").click();
                                    }, 100);

                                }
                            }
                        }}
                    >
                        CLEAR
                        {/* {closeIcon} */}
                        </div>
                }
            </>
        }
    </div>;
}


export function ProxySettings({ isDarkMode=true, currentItemData={}, setCurrentItemData=()=>{}, setIndexSetError=()=>{}, orchestratorConfig={} }) {

return (
    <>
    {InputElement(
        "http_proxy",
        isDarkMode,
        setCurrentItemData,
        false,
        null,
        setIndexSetError,
        orchestratorConfig?.http_client,
        null,
        "ex : https://proxy.appfactor.io:8443"
    )}

    {InputElement(
        "proxyUser",
        isDarkMode,
        setCurrentItemData,
        false,
        null,
        setIndexSetError,
        currentItemData
    )}

    {InputElement(
        "proxyPassword",
        isDarkMode,
        setCurrentItemData,
        false,
        null,
        setIndexSetError,
        currentItemData
    )}
    </>)
    
}


/* What each tab is called, in one place now that two windows show them. */
const TAB_LABELS = {
    global: "Global",
    proxy: "Proxy settings",
    certs: "CA Certs",
};

export default function ScanSettingsPage({
    isDarkMode, gdata, mData, setOpenAddIndexPage, openAddIndexPage, refreshDataSources,
    /* Drawn without its dialog, for the settings window - which brings its own
       frame, its own heading and its own way out. */
    inline = false,
    /* Which of its three tabs this instance carries. */
    tabs = ["global", "proxy", "certs"],
    /* Told when the orchestrator answers with its configuration, so a window
       hosting this inline can say "not connected" until it does. */
    onConfig,
}) {

    const MY_ID = "55335533-0000-0000-0000-000000000001";
    const tabValues = tabs.filter(t => TAB_LABELS[t]);
    const [activeTab, setActiveTab] = useState(() => tabValues[0] || "global");
    const [orchestratorConfig, setOrchestratorConfig] = useState(null);

    useEffect(() => {
        if (openAddIndexPage) {

            let orchestratorStatus = {
                "type": "get_scanner_config",
                "id": MY_ID
            };

            setTimeout(() => {
                wPostMessage(orchestratorStatus);
            }, 200);

            function processIncomming(event) {
                try {
                    let eventData = {
                        ...(typeof event.data !== 'undefined') ? JSON.parse(event.data) : {},
                    };

                    if (eventData.id == MY_ID && eventData.type == "scanner_config") {
                        setOrchestratorConfig(eventData.scanner_config);
                        if (onConfig) onConfig(eventData.scanner_config);
                        setCurrentItemData({
                            ...(eventData.scanner_config || {}),
                        })

                    }
                } catch (e) { /* */ }
            }

            window.addEventListener("message", processIncomming, false);

            return () => {
                window.removeEventListener("message", processIncomming, false);
            }
        }
    }, [openAddIndexPage]);

    const [indexSetError, setIndexSetError] = useState(null);

    function createNewSettings(data) {
        window.setIndexSetError = setIndexSetError;
        window.closeAddIndexPage = () => setOpenAddIndexPage(false);

        try {
            window.removeEventListener("message", processCreation, false);
        } catch (e) {
            /**/
        }

        window.addEventListener("message", processCreation, false);

        if (!window.payloadData) {
            window.payloadData = {};
        }

        let rndVal = (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000));

        let justUpdateWithoutNewUserPass = true;

        if (data?.newUserPass && data.http_client.http_proxy && data.http_client.http_proxy.length > 0) {
            justUpdateWithoutNewUserPass = false;
        }

        if (justUpdateWithoutNewUserPass) {
            let newrID = UID_CREATE + rndVal;

            window.payloadData[newrID] = {
                orchestratorConfig: orchestratorConfig,
                payloadData: {
                    ...data
                }
            }
            try {
                setNewConfig(newrID)
            } catch (e) {
                console.log("setNewConfig error", e);
            }

            return;
        }

        let rID = UID_CREATE + rndVal;

        window.payloadData[rID] = {
            orchestratorConfig: orchestratorConfig,
            payloadData: {
                ...data
            },
            payloadSecret: {
                "type": "add_secret",
                "id": rID,
                "secret_key": data.proxyUser + "_secret" + rndVal,
                "secret": {
                    "type": `username_password`,
                    "user_name": data.proxyUser,
                    "password": data.proxyPassword
                }
            },
        };

        window.postMessage(
            JSON.stringify({
                type: APPFACTOR.command,
                scanRaw: true,
                payload: window.payloadData[rID].payloadSecret
            })
        );
    }

    const [currentItemData, setCurrentItemData] = useState({
        type: "orchestratorConfig",

    });


    let sizes = {
        width: 777,
        height: 600,
    }

    const buttonRef = useRef(null);

    /* The settings themselves, apart from the window they are shown in: the
       scanner opens them in its own dialog, and the product's settings window
       shows the same thing inside its own frame. */
    const body = (<>

                    {indexSetError && <div style={{
                        position: "absolute",
                        marginTop: -8,
                        fontSize: 11,
                        width: "100%",
                        height: 42,
                        color: "red",
                    }}>{indexSetError}</div>
                    }

                    {orchestratorConfig && (<>

                        <br/>
                        <div
                        style={{
                            marginLeft: 155,
                        }}
                        >
                        {/* One tab is no choice, so the strip only appears when
                            this instance carries more than one of them. */}
                        {tabValues.length > 1 && (
                        <HorizontalMenu
                            addLabel={false}
                            noScale={true}
                            alignleft={true} 
                            value={activeTab}
                            setValue={setActiveTab}
                        menuValues={tabValues}
                        menuItems={tabValues.map(v => (
                            <div key={v} style={{ display: "inline-block" }}>{TAB_LABELS[v]}</div>
                        ))}

                        onChangeValue={(e, val) => {
                            if( val  ){
                                setActiveTab(val);
                            }
                        }}
                        />
                        )}
                        </div>
                        <br/>
                        <br/>
                        


                        <div 
                        style={{
                            minHeight:300,
                          position: activeTab == "global" ? "relative" : "absolute",
                          opacity: activeTab == "global" ? 1 : 0,
                          pointerEvents: activeTab == "global" ? "auto" : "none",
                          marginLeft:120,
                        }}
                        >
                        {InputElement(
                            "api_url_prefix",
                            isDarkMode,
                            setCurrentItemData,
                            true,
                            null,
                            setIndexSetError,
                            orchestratorConfig
                        )}
                        <FormControlLabel
                            style={{
                                marginTop: -10,
                                padding: 0,
                                marginBottom: 0,
                                marginLeft: 155,
                            }}
                            control={
                                <Checkbox
                                    {...(currentItemData?.keep_downloaded_scanner ? { checked: true } : {})}
                                    onChange={(e) => {
                                        setCurrentItemData(prev => {
                                            let newVal = {
                                                ...prev,
                                                keep_downloaded_scanner: e.target.checked
                                            }

                                            return newVal
                                        })
                                    }}
                                />
                            }
                            label="Keep downloaded scanner"
                            slotProps={{
                                typography: {
                                    style: {
                                        color: isDarkMode ? "white" : "black",
                                        opacity: 0.5,
                                        fontSize: '13px'
                                    }
                                }
                            }}

                        />

                        <FormControlLabel
                            style={{
                                marginTop: -10,
                                padding: 0,
                                marginBottom: 0,
                                marginLeft: 155,
                            }}
                            control={
                                <Checkbox
                                defaultValue={localStorage[DEBUG_LEVEL_VAL] && `${localStorage[DEBUG_LEVEL_VAL]}` == "true" ? true : false}
                                    
                                    onChange={(e) => {
                                        localStorage[DEBUG_LEVEL_VAL] = `${e.target.checked}`;
                                    }}
                                />
                            }
                            label="Orchestrator Debug level"
                            slotProps={{
                                typography: {
                                    style: {
                                        color: isDarkMode ? "white" : "black",
                                        opacity: 0.5,
                                        fontSize: '13px'
                                    }
                                }
                            }}

                        />

                       
                       </div>

                       <div 
                        style={{
                            minHeight:300,
                          position: activeTab == "proxy" ? "relative" : "absolute",
                          opacity: activeTab == "proxy" ? 1 : 0,
                          pointerEvents: activeTab == "proxy" ? "auto" : "none",
                        }}>
                            <br/>
                            <ProxySettings isDarkMode={isDarkMode} currentItemData={currentItemData} setCurrentItemData={setCurrentItemData} setIndexSetError={setIndexSetError} orchestratorConfig={orchestratorConfig}/>
                        </div>


                        <div 
                        style={{
                            minHeight:300,
                          position: activeTab == "certs" ? "relative" : "absolute",
                          opacity: activeTab == "certs" ? 1 : 0,
                          pointerEvents: activeTab == "certs" ? "auto" : "none",
                        }}>
                            <br/>


                        <FormControlLabel
                            style={{
                                marginTop: 10,
                                padding: 0,
                                marginBottom: 0,
                                marginLeft: 140,
                            }}
                            control={
                                <Checkbox
                                    {...(currentItemData?.http_client?.ignore_certificate_errors ? { checked: true } : {})}
                                    onChange={(e) => {
                                        setCurrentItemData(prev => ({
                                            ...prev,
                                            http_client: {
                                                ...(prev.http_client ? { ...prev.http_client } : {}),
                                                ignore_certificate_errors: e.target.checked
                                            }
                                        }))
                                    }}
                                />
                            }
                            label="Ignore certificate errors"
                            slotProps={{
                                typography: {
                                    style: {
                                        color: isDarkMode ? "white" : "black",
                                        opacity: 0.5,
                                        fontSize: '13px'
                                    }
                                }
                            }}

                        />

                        {InputElement(
                            "extra_ca_certs_file",
                            isDarkMode,
                            setCurrentItemData,
                            false,
                            null,
                            setIndexSetError,
                            orchestratorConfig.http_client,
                            "extra_ca_certs"
                        )}

                        {InputElement(
                            "extra_ca_certs",
                            isDarkMode,
                            setCurrentItemData,
                            false,
                            null,
                            setIndexSetError,
                            orchestratorConfig.http_client,
                            "extra_ca_certs_file",
                        )}

                        {/* ignore_certificate_errors */}
                        </div>

                    </>
                    )}

                    <div style={{
                        position: "absolute",
                        marginTop: 6,
                        marginLeft: 220,
                        // bottom: 4,
                        width: "calc(100% - 220px)",
                        height: "180px",
                        overflow: "hidden",
                    }}>
                        <Button
                            id="saveSettingsButton"
                            ref={buttonRef}
                            style={{
                                color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
                                fontSize: 14,
                                marginTop: 24,
                                // marginLeft:-86,
                                maxWidth: 128,
                                minWidth: 128,
                                maxHeight: 32,
                                minHeight: 22,
                                padding: "4px !important",
                                borderRadius: 4,
                                border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                            }}
                            onClick={(event) => {
                                let http_proxy_url = currentItemData?.http_proxy;
                                let http_proxy_auth_secret_ref = "proxy_secret_ref_" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000));

                                let newSettings = {
                                    ...orchestratorConfig,
                                    http_client: {
                                        ...orchestratorConfig.http_client,
                                        ...(currentItemData?.extra_ca_certs_file ? {
                                            extra_ca_certs_file: currentItemData.extra_ca_certs_file,
                                        } : {}),
                                        ...(currentItemData?.extra_ca_certs ? {
                                            extra_ca_certs: currentItemData.extra_ca_certs,
                                        } : {}),
                                        ignore_certificate_errors: `${currentItemData?.http_client?.ignore_certificate_errors}` == `true` ? true : false,
                                        ...(http_proxy_url?.length > 0 ? {
                                            http_proxy: http_proxy_url,
                                        } : {}),
                                        ...(currentItemData?.newUserPass ? {
                                            http_proxy_auth_secret_ref: http_proxy_auth_secret_ref,
                                        } : {}),
                                    },
                                    keep_downloaded_scanner: `${currentItemData?.keep_downloaded_scanner}` == `true` ? true : false,
                                    ...(currentItemData?.newUserPass ? {
                                        newUserPass: true,
                                        proxyUser: currentItemData.proxyUser,
                                        proxyPassword: currentItemData.proxyPassword
                                    } : {}),
                                }

                                setIndexSetError("")
                                event.preventDefault();
                                event.stopPropagation();

                                let error = false;

                                if( currentItemData?.deleteNewUserPass ){
                                    try{ delete newSettings.newUserPass; } catch(e) { /**/ }
                                    try{ delete newSettings.proxyUser; } catch(e) { /**/ }
                                    try{ delete newSettings.proxyPassword; } catch(e) { /**/ }
                                    try{ delete newSettings.http_client; } catch(e) { /**/ }
                                    newSettings.deleteNewUserPass = true
                                }
                                else{
                                    if (!currentItemData?.api_url_prefix || currentItemData?.api_url_prefix?.length === 0) {
                                        error = true;
                                        setIndexSetError(p => ((p ? (p + ", ") : "") + `API url cannot be empty`));
                                    }
    
                                    if (currentItemData?.http_proxy_url?.length > 0) {
                                        if (!currentItemData?.proxyUser || currentItemData?.proxyUser?.length === 0) {
                                            error = true;
                                            setIndexSetError(p => ((p ? (p + ", ") : "") + `Proxy user cannot be empty`));
                                        }
    
                                        if (!currentItemData?.proxyPassword || currentItemData?.proxyPassword?.length === 0) {
                                            error = true;
                                            setIndexSetError(p => ((p ? (p + ", ") : "") + `Proxy password cannot be empty`));
                                        }
                                    }
                                }

                                if (error == false) {

                                    enqueueSnackbar("Orchestrator settings saved successfully",
                                        {
                                        ...infoOptions,
                                        anchorOrigin:{
                                            vertical:"top",
                                            horizontal:"center"
                                        },
                                        action: (key) => (
                                            <Button
                                                style={{color:"#FEFEFE"}}
                                            onClick={() => closeSnackbar(key)}>
                                                <CloseIcon />
                                            </Button>
                                        )
                                    })

                                    window.newSettingsValue = newSettings;
                                    createNewSettings(newSettings);
                                }

                            }}>SAVE</Button>

                        <Button
                            style={{
                                color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
                                fontSize: 14,
                                marginTop: 24,
                                marginLeft: 20,
                                maxWidth: 128,
                                minWidth: 128,
                                maxHeight: 32,
                                minHeight: 22,
                                padding: "4px !important",
                                borderRadius: 4,
                                border: isDarkMode ? "1px solid rgba(42,42,42,0)" : "1px solid rgba(0,0,0,0.142)",
                            }}
                            onClick={(event) => {
                                setOpenAddIndexPage(false);
                            }}>CANCEL</Button>
                    </div>

    </>);

    /* Inline: no dialog, no title - the window around it has both. */
    if (inline) {
        return <div className="orchestrator-inline">{body}</div>;
    }

    return (
        <>
            <Dialog
                keepMounted
                style={{
                    padding: 0,
                    margin: 0,
                }}
                slotProps={{
                    paper: {
                        sx: {
                            color: isDarkMode ? "white" : "black",
                            opacity: 1,
                            padding: 0,
                            margin: 0,
                            minWidth: sizes.width,
                            minHeight: sizes.height,
                            background: "transparent !important"
                        }
                    }
                }}

                open={openAddIndexPage}
                onClose={() => setOpenAddIndexPage(false)}>
                <div
                    style={{
                        zIndex: -1,
                        position: "absolute",
                        top: window.innerHeight <800?window.innerHeight/5.2:0,
                        marginTop: 0,
                        marginLeft: -26,
                        width: sizes.width + 26,
                        height: sizes.height + 12,
                        overflow: "hidden",
                        background: "transparent !important"
                    }}
                >

                    <MainBg isDarkMode={isDarkMode} width={sizes.width + 50} height={sizes.height} ></MainBg>
                </div>

                <DialogTitle
                    style={{
                        paddingTop: window.innerHeight <800?window.innerHeight/4:60,
                        paddingLeft: 40,
                        // margin: 0,
                    }}
                >
                    <div style={{
                        fontSize: 16,
                        marginTop: -14
                    }}>
                        Orchestrator configuration
                    </div>
                    <div style={{
                        fontSize: 13,
                        opacity: 0.5,
                        marginBottom: 32
                    }}>
                        Configure the orchestrator settings.
                    </div>

                </DialogTitle>
                <DialogContent
                    sx={{
                        padding: 0,
                        paddingLeft: "40px",
                        paddingRight: "40px",
                        margin: 0,
                        marginTop: "-40px",
                        maxWidth: "700px",
                    }}
                >
                    {body}
                </DialogContent>

            </Dialog>
        </>

    )

    function TypeSelector(type, setType, active, index) {
        const [isSelected, setIsSelected] = useState(false);
        const [lastActiveElement, setLastActiveElement] = useState("input_name");
        return <div
            key={"ts-" + index}
            onMouseDown={() => {
                try {
                    setLastActiveElement(document.activeElement.id);
                } catch (e) {
                    /**/
                }
            }}
            onMouseEnter={() => {
                setIsSelected(true);
            }}
            onMouseLeave={() => {
                if (!isSelected) {
                    return;
                }
                setIsSelected(false);
            }}
            style={{
                // filter: (active || isSelected )? "none" : "grayscale(100%)",
                transition: "all 0.2s ease-in-out",
                cursor: "pointer",
                scale: isSelected ? 1 : 0.8,
                width: "64px",
                height: "64px",
                borderRadius: 8,
                marginLeft: 10,
                // position: "absolute",
                backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(224,224,224,1)",
                top: 14,
                left: 14,
                border: active ? "1.42px solid rgb(217, 28, 33)" : "1.42px solid rgba(255,255,255,0.10)",
            }}
            onClick={() => {
                setType(prev => ({
                    ...prev,
                    type: type
                }));

                try {
                    document.getElementById(lastActiveElement).focus();
                } catch (e) {
                    /**/
                }
            }}
        >

            <div
                className="arepoLink"
                style={{
                    position: "absolute",
                    marginTop: 6,
                    marginLeft: 6,
                    width: 50,
                    height: 50,
                    minWidth: 30,
                    minHeight: 30,
                    borderRadius: "99em",
                    backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(24,24,24,1)",
                    backgroundSize: "46px 46px",
                    backgroundPosition: "2px 2px",
                    backgroundRepeat: "no-repeat",
                    fontSize: 10,
                    color: "rgba(255,255,255,0.5)",
                    backgroundImage: `url(${getApplicationImage(
                        type, "AppComponent",
                        isDarkMode
                    )})`
                }}
            ></div>
            <div style={{
                position: "absolute",
                marginTop: 26,
                marginLeft: 0,
                bottom: -16,
                fontSize: 10,
                width: 64,
                textAlign: "center",
                height: 10,
                textDecoration: active ? "underline 1.42px solid rgb(217, 28, 33)" : "none",
                textTransform: "uppercase",
            }}>{type}</div>
        </div>;
    }
}


export { ScanSettingsPage };